import React from 'react';
import { StyleSheet, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { managementConstants } from 'services/redux/management/constants'
import { setManagement } from 'services/redux/management/actions'
import ThemedDatepicker from 'components/atoms/ThemedDatepicker'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import HelperDate from 'utils/helper-date'
import { selectManagementSelectedEndDate, selectManagementSelectedStartDate } from 'services/redux/management/reducers'

const ManagementDateSelector = ({ mode = 'single' }) => {
	
	const dispatch = useDispatch()
	
	const _selectedStartDate = useSelector( selectManagementSelectedStartDate )
	const _selectedEndDate = useSelector( selectManagementSelectedEndDate )
	
	const managementSelectedStartDate = _selectedStartDate ?? HelperDate.ymd();
	const managementSelectedEndDate = _selectedEndDate ?? HelperDate.ymd();
	
	const setSelectedSingleDate = ( selectedDate ) => {
		dispatch( setManagement( managementConstants.MANAGEMENT_SELECTED_START_DATE, HelperDate.date( selectedDate ) ) )
	}
	
	const iconCalendar = <Icon icon={ IconSystemConstants.CALENDAR } />
	
	return (
		<View style={ styles.row }>
			{ mode !== 'single' && (
				<View style={ styles.column }>
					<ThemedDatepicker
						date={ HelperDate.date( managementSelectedStartDate ) }
						accessoryRight={ iconCalendar }
						style={ styles.calendarPicker }
						onSelect={ setSelectedSingleDate }
					/>
				</View>
			)}
			
			<View 
				style={ styles.column }>

				{ mode === 'single' ? (
					<ThemedDatepicker
						date={ HelperDate.date( managementSelectedStartDate ) }
						accessoryRight={ iconCalendar }
						style={ styles.calendarPicker }
						onSelect={ setSelectedSingleDate }
					/>
				) : (
					<ThemedDatepicker
						date={ HelperDate.date( managementSelectedStartDate ) }
						accessoryRight={ iconCalendar }
						style={ styles.calendarPicker }
						onSelect={ setSelectedSingleDate }
					/>
				)}
			</View>
		</View>
	)
}

const styles = StyleSheet.create({
	datePickerContainer: {
		alignItems: 'flex-end'
	},
	row: {
	},
	column: {
		flex: 1,
	},
	calendarPicker: {
		flex: 1,
	}
});

export default ManagementDateSelector
